import { forwardRef } from 'react';
import BlockLoader from 'components/ui/ContentBlocks/BlockLoader';
import type { TreatmentPage } from 'types/contentful/generated/graphql';

type Props = {
  entry: TreatmentPage;
};

const Details = forwardRef<HTMLElement, Props>(
  ({ entry }, ref): JSX.Element => (
    <section ref={ref} id="details" className="text-primary">
      <div className="max-w-screen-xl mx-auto px-5 md:px-4">
        <h2 className="font-netto text-navy text-3xl mb-6">
          {entry.detailsTitle}
        </h2>
      </div>
      <div>
        <BlockLoader entry={entry.detailsCollection} />
      </div>
    </section>
  ),
);

Details.displayName = 'Details';
export default Details;
